<script setup>
import useVuelidate from '@vuelidate/core'
import { required } from '@vuelidate/validators'
import { reactive } from 'vue'

import InputText from '@/components/form/InputText.vue'
import FunnelStep from '@/components/FunnelStep.vue'
import { useStudentStore } from '@/stores/StudentStore'

const studentStore = useStudentStore()

defineProps({
  id: {
    type: Number,
    required: true
  },
  name: {
    type: String,
    required: true
  },
  isActive: {
    type: Boolean,
    required: true
  },
  isCompleted: {
    type: Boolean,
    required: true
  }
})

const state = reactive({
  error: '',
  form: {
    cardNumber: '',
    cardHolder: ''
  }
})

const validation = {
  cardNumber: {
    required,
    $autoDirty: true
  },
  cardHolder: {
    required,
    $autoDirty: true
  }
}

const $v = useVuelidate(validation, state.form, { $stopPropagation: true })

const emits = defineEmits(['onClickCompleteStep', 'onChangeClicked'])

const handleContinue = () => {
  if (studentStore.cardNumber) {
    emits('onClickCompleteStep')
  } else {
    $v.value.$touch()
    if ($v.value.$anyDirty && !$v.value.$error) {
      studentStore
        .validateStudentCard(state.form.cardNumber, state.form.cardHolder)
        .then((isCardValid) => {
          if (isCardValid) {
            emits('onClickCompleteStep')
          }
        })
        .catch((error) => console.error(error))
    }
  }
}
</script>

<template>
  <FunnelStep
    :id="id"
    :name="name"
    :details="$t('ISIC/ITIC verification')"
    :is-active="isActive"
    :is-completed="isCompleted"
    @on-change-clicked="$emit('onChangeClicked')"
  >
    <div class="step-verification__form">
      <div class="input-group">
        <div class="input-label">{{ $t('First and last name') }}</div>
        <InputText v-model="$v.cardHolder.$model" :validator="$v.cardHolder" placeholder="" />
      </div>

      <div class="input-group">
        <div class="input-label">{{ $t('ISIC/ITIC number') }}</div>
        <InputText
          v-model="$v.cardNumber.$model"
          :validator="$v.cardNumber"
          :error="studentStore.error"
          @keyup="studentStore.resetErrorResponse"
          placeholder="S123456789012X"
        />
      </div>

      <div class="input-group button-group">
        <button
          @click="handleContinue"
          :class="{
            'button button--large button--primary step-account__button': true,
            disabled: $v.$error || studentStore.error || studentStore.isSubmitting
          }"
        >
          {{ $t('Continue') }}
        </button>
      </div>
    </div>
  </FunnelStep>
</template>
